import MarketTransactionDetailsItem, {
  MarketTransactionDetailsItemProps,
} from "#/ui/Market/TransactionDetailsModal/MarketTransactionDetailsItem"

type MarketTransactionDetailsContentProps = {
  details: MarketTransactionDetailsItemProps[]
}

export default function MarketTransactionDetailsContent({
  details,
}: MarketTransactionDetailsContentProps) {
  return (
    <>
      {details.map((item) => (
        <MarketTransactionDetailsItem
          key={item.label}
          label={item.label}
          value={item.value}
          type={item.type}
          onClick={item.onClick}
        />
      ))}
    </>
  )
}
